// filepath: c:\Users\USER\Desktop\GitHub Repos\github-emu-portal\src\components\MainNavBar\MainNavBar.jsx
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { DescriptionOutlined, LoginOutlined, SupportAgentOutlined } from "@mui/icons-material";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import EngineeringIcon from "@mui/icons-material/Engineering";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";

import { specificUserEmails } from "components/RequireSpecificEmails/requireSpecificEmails";

import "./sideNavbar.css";

const SideNavBar = () => {
    const [collapsed, setCollapsed] = useState(true);
    const sidebarRef = React.useRef(null);

    // Get user's first name from Redux
    const firstName = useSelector(state => state.auth?.userAccount?.givenName);
    // const allPermissions = useSelector(state => state.auth?.permissions || []);
    // const isEnterpriseAdmin = Array.isArray(allPermissions) && allPermissions.some(
    //     perm => perm.userType === "Owner"
    // );

    const userEmail = useSelector(state => state.auth?.userAccount?.username || "").toLowerCase();
    const isSpecificUser = specificUserEmails.includes(userEmail);

    // Handle scroll position for fixed sidebar
    useEffect(() => {
        const handleScroll = () => {
            if (sidebarRef.current) {
                if (window.scrollY > 64) {
                    sidebarRef.current.classList.add('fixed-sidebar');
                } else {
                    sidebarRef.current.classList.remove('fixed-sidebar');
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className={`main-sidebar-wrapper ${collapsed ? 'collapsed' : ''}`} >
            <aside className="main-sidebar" ref={sidebarRef}>
                <div className="sidebar-header">
                    <EngineeringIcon className="sidebar-logo" />
                    {!collapsed && <span className="sidebar-title"> {firstName ? `Welcome ${firstName}!` : ""}</span>}
                    <button
                        className="collapse-btn"
                        onClick={() => setCollapsed(!collapsed)}
                        aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
                    >
                        {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </button>
                </div>

                <div className="sidebar-divider"></div>

                <nav className="sidebar-nav">
                    <NavLink
                        to="/dashboard"
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                        title="Home Dashboard"
                    >
                        <HomeOutlinedIcon className="nav-icon" />
                        {!collapsed && <span className="nav-text">Home Dashboard</span>}
                    </NavLink>

                    <NavLink
                        to="/global-orgs"
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                        title="Organizations"
                    >
                        <ViewListOutlinedIcon className="nav-icon" />
                        {!collapsed && <span className="nav-text">Organizations</span>}
                    </NavLink>

                    {isSpecificUser && (
                        <NavLink
                            to="/ecr-ops"
                            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                            title="ECR Ops Portal"
                        >
                            <AutoAwesomeIcon className="nav-icon" />
                            {!collapsed && <span className="nav-text">ECR Ops Portal</span>}
                        </NavLink>
                    )}
                    <NavLink
                        to="https://deloitteglobal.service-now.com/sp?id=sc_cat_item&sys_id=4a417b4f1b17855cbcae55b0604bcb1c"
                        className="nav-item"
                        title="Support Ticket"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <SupportAgentOutlined className="nav-icon" />
                        {!collapsed && <span className="nav-text">Support Ticket</span>}
                    </NavLink>

                    <NavLink
                        to="https://github.com/enterprises/deloitte-global/sso"
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                        title="GitHub Sign-In"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <LoginOutlined className="nav-icon" />
                        {!collapsed && <span className="nav-text">GitHub Sign-In</span>}
                    </NavLink>

                    <NavLink
                        to="https://developer.deloitte.com/enterprisecoderepository/"
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                        title="ECR Documentation"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <DescriptionOutlined className="nav-icon" />
                        {!collapsed && <span className="nav-text">ECR Documentation</span>}
                    </NavLink>
                </nav>
            </aside>
        </div>
    );
};

export default SideNavBar;